import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="home">
      <section className="hero" data-animate="fade-in">
        {/* Animated Trading Indicators Background */}
        <div className="trading-indicators">
          <div className="chart-line line-1"></div>
          <div className="chart-line line-2"></div>
          <div className="chart-line line-3"></div>
          <div className="chart-line line-4"></div>
          <div className="candlestick-container">
            <div className="candlestick green"></div>
            <div className="candlestick red"></div>
            <div className="candlestick green"></div>
            <div className="candlestick red"></div>
            <div className="candlestick green"></div>
          </div>
          <div className="volume-bars">
            <div className="volume-bar"></div>
            <div className="volume-bar"></div>
            <div className="volume-bar"></div>
            <div className="volume-bar"></div>
            <div className="volume-bar"></div>
            <div className="volume-bar"></div>
          </div>
          <div className="moving-averages">
            <div className="ma-line ma-20"></div>
            <div className="ma-line ma-50"></div>
            <div className="ma-line ma-200"></div>
          </div>
        </div>

        {/* Floating Trading Instruments - Left Side */}
        <div className="floating-instruments left-side">
          <div className="instrument-item float-1 forex">
            <span className="symbol">€/$</span>
            <span className="price">1.0856</span>
            <div className="mini-chart">
              <div className="chart-spark spark-up"></div>
            </div>
          </div>
          <div className="instrument-item float-2 crypto">
            <span className="symbol">₿</span>
            <span className="price">$35,240</span>
            <div className="mini-chart">
              <div className="chart-spark spark-down"></div>
            </div>
          </div>
          <div className="instrument-item float-3 commodity">
            <span className="symbol">GOLD</span>
            <span className="price">$2,685</span>
            <div className="mini-chart">
              <div className="chart-spark spark-up"></div>
            </div>
          </div>
          <div className="instrument-item float-4 stock-logo">
            <div className="logo-container">
              <span className="company-symbol">AAPL</span>
              <div className="apple-logo">🍎</div>
              <div className="trend-arrow arrow-up">📈</div>
            </div>
          </div>
          <div className="instrument-item float-5 stock-logo">
            <div className="logo-container">
              <span className="company-symbol">TSLA</span>
              <div className="tesla-logo">⚡</div>
              <div className="trend-arrow arrow-down">📉</div>
            </div>
          </div>
          <div className="instrument-item float-6 forex">
            <span className="symbol">GBP/USD</span>
            <span className="price">1.2945</span>
            <div className="mini-chart">
              <div className="chart-spark spark-up"></div>
            </div>
          </div>
          <div className="instrument-item float-7 stock-logo">
            <div className="logo-container">
              <span className="company-symbol">NVDA</span>
              <div className="nvidia-logo">🔥</div>
              <div className="trend-arrow arrow-up">📈</div>
            </div>
          </div>
          <div className="instrument-item float-8 commodity">
            <span className="symbol">SILVER</span>
            <span className="price">$31.45</span>
            <div className="mini-chart">
              <div className="chart-spark spark-down"></div>
            </div>
          </div>
        </div>

        {/* Floating Trading Instruments - Center Left */}
        <div className="floating-instruments center-left">
          <div className="instrument-item float-3 index">
            <span className="symbol">DAX</span>
            <span className="price">15,840</span>
            <div className="mini-chart">
              <div className="chart-spark spark-up"></div>
            </div>
          </div>
          <div className="instrument-item float-6 stock-logo">
            <div className="logo-container">
              <span className="company-symbol">AMZN</span>
              <div className="amazon-logo">📦</div>
              <div className="trend-arrow arrow-up">📈</div>
            </div>
          </div>
          <div className="instrument-item float-9 forex">
            <span className="symbol">AUD/USD</span>
            <span className="price">0.6745</span>
            <div className="mini-chart">
              <div className="chart-spark spark-down"></div>
            </div>
          </div>
        </div>

        {/* Floating Trading Instruments - Center Right */}
        <div className="floating-instruments center-right">
          <div className="instrument-item float-2 crypto">
            <span className="symbol">BNB</span>
            <span className="price">$620</span>
            <div className="mini-chart">
              <div className="chart-spark spark-up"></div>
            </div>
          </div>
          <div className="instrument-item float-5 stock-logo">
            <div className="logo-container">
              <span className="company-symbol">META</span>
              <div className="meta-logo">📘</div>
              <div className="trend-arrow arrow-down">📉</div>
            </div>
          </div>
          <div className="instrument-item float-8 commodity">
            <span className="symbol">COPPER</span>
            <span className="price">$4.15</span>
            <div className="mini-chart">
              <div className="chart-spark spark-up"></div>
            </div>
          </div>
        </div>

        {/* Floating Trading Instruments - Right Side */}
        <div className="floating-instruments right-side">
          <div className="instrument-item float-1 forex">
            <span className="symbol">USD/JPY</span>
            <span className="price">149.85</span>
            <div className="mini-chart">
              <div className="chart-spark spark-down"></div>
            </div>
          </div>
          <div className="instrument-item float-2 index">
            <span className="symbol">S&P500</span>
            <span className="price">5,820</span>
            <div className="mini-chart">
              <div className="chart-spark spark-up"></div>
            </div>
          </div>
          <div className="instrument-item float-3 commodity">
            <span className="symbol">OIL</span>
            <span className="price">$68.45</span>
            <div className="mini-chart">
              <div className="chart-spark spark-down"></div>
            </div>
          </div>
          <div className="instrument-item float-4 stock-logo">
            <div className="logo-container">
              <span className="company-symbol">MSFT</span>
              <div className="microsoft-logo">⊞</div>
              <div className="trend-arrow arrow-up">📈</div>
            </div>
          </div>
          <div className="instrument-item float-5 stock-logo">
            <div className="logo-container">
              <span className="company-symbol">ADBE</span>
              <div className="adobe-logo">🅰</div>
              <div className="trend-arrow arrow-up">📈</div>
            </div>
          </div>
          <div className="instrument-item float-6 crypto">
            <span className="symbol">ETH</span>
            <span className="price">$2,640</span>
            <div className="mini-chart">
              <div className="chart-spark spark-up"></div>
            </div>
          </div>
          <div className="instrument-item float-7 stock-logo">
            <div className="logo-container">
              <span className="company-symbol">GOOGL</span>
              <div className="google-logo">🌐</div>
              <div className="trend-arrow arrow-up">📈</div>
            </div>
          </div>
          <div className="instrument-item float-8 index">
            <span className="symbol">NASDAQ</span>
            <span className="price">18,540</span>
            <div className="mini-chart">
              <div className="chart-spark spark-up"></div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="hero-content">
            <img src="/logo.png" alt="UPM Traders Logo" className="hero-logo fade-in" />
            <h1 className="fade-in brand-title">UPM Traders</h1>
            <h1 className="fade-in">Ultimate Profit in Money</h1>
            <p className="fade-in delay-1">Professional Trading Signals & Education for Serious Traders</p>
            <div className="hero-buttons fade-in delay-2">
              <Link to="/services" className="btn">Get Trading Signals</Link>
              <Link to="/education" className="btn secondary">Start Learning</Link>
            </div>
          </div>
        </div>
      </section>
      
      <section className="who-we-are" data-animate="fade-in">
        <div className="container">
          <h2>Who We Are</h2>
          <div className="who-we-are-content">
            <p className="intro-text">
              UPM Traders is a leading provider of professional trading signals, education, and market analysis. 
              With years of experience in the financial markets, we are dedicated to empowering traders of all levels 
              to achieve their financial goals through data-driven insights and expert guidance.
            </p>
            
            <div className="who-grid">
              <div className="who-item fade-in delay-1">
                <div className="who-icon">🎯</div>
                <h3>Our Mission</h3>
                <p>
                  To provide traders with accurate, timely, and profitable trading signals while fostering 
                  a community of educated and successful traders through comprehensive education and support.
                </p>
              </div>
              
              <div className="who-item fade-in delay-2">
                <div className="who-icon">👁️</div>
                <h3>Our Vision</h3>
                <p>
                  To become the world's most trusted trading education and signals platform, known for 
                  transparency, accuracy, and unwavering commitment to our traders' success.
                </p>
              </div>
              
              <div className="who-item fade-in delay-3">
                <div className="who-icon">⭐</div>
                <h3>Our Values</h3>
                <p>
                  Integrity, transparency, continuous learning, risk management, and putting our traders first. 
                  We believe in sustainable trading practices and long-term success over quick gains.
                </p>
              </div>
            </div>
            
            <div className="stats-row fade-in delay-4">
              <div className="stat-item">
                <h4>10+</h4>
                <p>Years of Experience</p>
              </div>
              <div className="stat-item">
                <h4>5000+</h4>
                <p>Active Traders</p>
              </div>
              <div className="stat-item">
                <h4>50+</h4>
                <p>Markets Covered</p>
              </div>
              <div className="stat-item">
                <h4>24/7</h4>
                <p>Market Coverage</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="services-preview" data-animate="fade-in">
        <div className="container">
          <h2>Our Professional Services</h2>
          <div className="service-grid">
            <div className="service-item fade-in delay-1">
              <h3>Trading Signals</h3>
              <p>Precise entry and exit points from professional traders</p>
              <Link to="/services/signals">Learn More</Link>
            </div>
            <div className="service-item fade-in delay-2">
              <h3>Education</h3>
              <p>Comprehensive courses for all levels of traders</p>
              <Link to="/education">Learn More</Link>
            </div>
            <div className="service-item fade-in delay-3">
              <h3>Webinar Training</h3>
              <p>Live sessions with industry experts</p>
              <Link to="/services/webinar">Learn More</Link>
            </div>
          </div>
        </div>
      </section>
      
      <section className="features" data-animate="fade-in">
        <div className="container">
          <div className="feature-grid">
            <div className="feature fade-in delay-1">
              <h3>Regulated Brokers</h3>
              <p>We partner with only the most trusted and regulated brokers in the industry</p>
            </div>
            <div className="feature fade-in delay-2">
              <h3>Professional Traders</h3>
              <p>Our team consists of experienced traders with proven track records</p>
            </div>
            <div className="feature fade-in delay-3">
              <h3>Market Analysis</h3>
              <p>Daily market insights and technical analysis from experts</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* MarketData removed per request; live instruments are now shown in the header ticker */}
    </div>
  );
};

export default Home;